import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function Printer() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState(null);

  const navigate = useNavigate();

  const addPrinter = (e) => {
    e.preventDefault();

    axios
      .put(
        `${apiKey}/api/rms/admin/printer/category/${selectedCategory.id}`,
        {
          printer: selectedPrinter,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Printer Added Successfully", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setShowModal(false);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    const checkJSPMStatus = () => true; // your jspmWSStatus()

    window.JSPM.JSPrintManager.auto_reconnect = true;
    window.JSPM.JSPrintManager.start();
    window.JSPM.JSPrintManager.WS.onStatusChanged = function () {
      if (checkJSPMStatus()) {
        //get client installed printers
        window.JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
          setPrinters(
            myPrinters.map((printer) => ({
              label: printer,
              value: printer,
            }))
          );
        });
      }
    };
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      axios
        .get(`${apiKey}/api/rms/admin/categories`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setCategories(res.data);
          setError(false);
        })
        .catch((err) => {
          setError(err.response?.data?.message || "Error Occured");
        })
        .finally(() => {
          setPageLoading(false);
        });
    };

    fetchCategories();
  }, [user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard message={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div>
          <button className=" mt-2 bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center">
            <Link>Download Driver From Thermal Printer</Link>
          </button>
          <button className=" mt-2 bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center">
            <Link to={"ProductCategory"}>{languageHelper("Product Printer")}</Link>
          </button>
        </div>

        <div>
          <h1 className="text-d-bg-text text-2xl font-semibold py-5">
            {languageHelper("Categories")}
          </h1>
        </div>
        <div className="flex flex-wrap gap-6">
          {categories &&
            categories.map((data) => (
              <div
                className="border-solid border-2 border-d-bg cursor-pointer rounded-2xl w-36 hover:transition-all hover:bg-d-bg group p-2 overflow-hidden"
                onClick={() => navigate(`ProductCategory/${data.id}`)}
              >
                <button
                  className="block ml-auto p-1 px-2"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevents the div's onClick from firing
                    setSelectedCategory(data);
                    setShowModal(true);
                  }}
                >
                  <BsThreeDotsVertical className="fill-d-bg-text group-hover:fill-white" />
                </button>

                <h1 className="align-start text-md font-semibold group-hover:text-white whitespace-nowrap">
                  {defaultLang === "text_en" ? data.category_name : data.cat_name_arabic}
                </h1>
                <div className="flex justify-end p-1">
                  <FaStar className="fill-orange-500" />
                </div>
              </div>
            ))}
        </div>

        {showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative mx-auto w-1/3">
                {/*content*/}
                <form
                  onSubmit={addPrinter}
                  className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none overflow-y-auto shiftmodel"
                >
                  {/*header*/}
                  <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
                    <h1 className="text-xl text-d-bg-text">
                      {languageHelper("Select Printer by Category")}
                    </h1>
                    <button
                      className=" ml-auto  float-right text-2xl"
                      onClick={() => setShowModal(false)}
                    >
                      <span className="text-d-bg-text"> × </span>
                    </button>
                  </div>
                  <hr className="min-h-0.5  w-auto mx-2" />
                  <div className="p-2">
                    <h2 className="">{languageHelper("Old Printer Name")}</h2>
                    <p className="text-sm font-semibold">
                      {selectedCategory?.add_port}
                    </p>
                  </div>
                  {/*body*/}
                  <div className="relative px-4 text-start ">
                    <div>
                      {printers?.length > 0 && (
                        <Select
                          type="text"
                          placeholder="Select Item"
                          className="placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                          required
                          options={printers}
                          onChange={(e) => setSelectedPrinter(e.value)}
                        />
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                    <button
                      className="text-d-bg-text  text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                      type="submit"
                      onClick={() => setShowModal(false)}
                    >
                      {languageHelper("Close")}
                    </button>

                    <button
                      className="text-d-bg-text text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                      type="submit"
                    >
                      {languageHelper("Save Changes")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
      </div>
    </main>
  );
}

export default Printer;
